import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TonyasBloomsWireframe from './TonyasBloomsWireframe';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TonyasBloomsWireframe />
  </React.StrictMode>
);
